import { Checkbox, Col, Row } from 'antd';
import ContainerFluid from 'app/components/Layout/ContainerFluid';
import { LoadingContainer } from 'app/components/LoadingContainer';
import useFetchData from 'app/hooks/useFetchData';
import styles from 'app/pages/Cart/components/PaymentInfo/styles.module.css';
import { getPaymentMethodApi } from 'app/services/checkoutApi';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import {
  BoxRight as SharedBoxRight,
  NoteBox,
  NoteTitle,
  NoteContent,
} from 'app/pages/PassengerInfo/components/PaymentStyles';
import { selectTranslations } from '../App/slice/selectors';
import HeaderStep from '../HolidayList/HeaderStep';
import ContactInformation from './ContactInformation';
import FlightInformation from './FlightInformation';
import PassengerInformation from './PassengerInformation';
import { PaymentHolidayInformationWrapper } from './styled';
import {
  formatNumber,
  openMessageWithIcon,
  renderReplaceText,
} from 'utils/helper';
import useWindowSize from 'app/hooks/useWindowSize';
import { SESSION_KEYS } from '../HolidayList/types';
import { usePassengerCount } from './hooks/usePassengerCount';
import { usePassengerNameLengthCheck } from './hooks/usePassengerNameLengthCheck';
import moment from 'moment';
import {
  getCommonAirportDataApi,
  getConfirmPriceApi,
  getCreateOrderHolidayApi,
} from 'app/services/holidayApi';
import { DocumentType } from '../PassengerInfo/types';
import { getCookie } from 'utils/cookies';
import { DEFAULT_LANGUAGE, TYPE_COOKIE } from 'utils/constants';
import _ from 'lodash';
import {
  clearComboSessionId,
  clearPassengerInfoForm,
  clearSelectedFlights,
  clearSelectedHotels,
  clearSelectedTickets,
  clearSpecialRequest,
  getPassengerInfoForm,
  getSelectedFlights,
  getSelectedHotels,
  getSelectedTickets,
  getSpecialRequest,
} from 'utils/sessionStorageHelper';
import { COMBO_HOLIDAY_TYPES } from '../BookingMask';
import { calculateHotelNights } from '../BookingMask/bookingMask.helpers';
import SpecialRequest from './SpecialRequestForm';
export const PaymentHolidayInformation = () => {
  const translations = useSelector(selectTranslations);
  const location = useLocation();
  const history = useHistory();
  const { device } = useWindowSize();
  const searchParams = new URLSearchParams(location.search);
  const paramCreateOrderRef = useRef<any>(null);
  const [isAgreeTerm, setIsAgreeTerm] = useState<boolean>(true);
  const [dataCombo, setDataCombo] = useState<any>();
  const [dataAllCombo, setDataAllCombo] = useState<any>();
  const [dataFlight, setDataFlight] = useState<any>();
  const [dataHotel, setDataHotel] = useState<any>();
  const [dataSpecialRequest, setDataSpecialRequest] = useState<any>();
  const [dataPassenger, setDataPassenger] = useState<any>();
  const [dataContact, setDataContact] = useState<any>();
  const [dataAirports, setDataAirports] = useState<any>();
  const checkin = searchParams.get('checkin') ?? '';
  const checkout = searchParams.get('checkout') ?? '';
  useEffect(() => {
    const tickets = getSelectedTickets();
    const flights = getSelectedFlights();
    const hotels = getSelectedHotels();
    const passengerInfo = getPassengerInfoForm();
    const specialRequest = getSpecialRequest();
    if (_.isEmpty(tickets) || _.isEmpty(flights) || _.isEmpty(passengerInfo)) {
      history.replace('/booking-mask');
    } else {
      setDataCombo(tickets?.[0].ticket);
      setDataAllCombo(tickets);
      setDataFlight(flights);
      setDataHotel(hotels);
      setDataPassenger(passengerInfo?.passengers || []);
      setDataContact(passengerInfo?.contact || {});
      setDataSpecialRequest(specialRequest || '');
      onFetchPaymentMethod();
      onFetchAirport();
    }
  }, []);
  const {
    result: resPaymentMethod,
    onFetchData: onFetchPaymentMethod,
    isLoading: isLoadingPaymentMethod,
  } = useFetchData({
    actionApi: getPaymentMethodApi,
    IIFE: false,
    payloadData: { ticketType: sessionStorage.getItem('ticketType') },
  });
  const { onFetchData: onFetchAirport } = useFetchData({
    actionApi: getCommonAirportDataApi,
    IIFE: false,
    onSuccess: response => {
      setDataAirports(response.data);
    },
  });

  const {
    totalAdultAndChild,
    textPassenger,
    totalAdult,
    totalChild,
    totalInfants,
    room,
  } = usePassengerCount(dataPassenger, {
    room: Number(searchParams.get('room') ?? '1'),
    hotelCount: dataHotel?.length || 0,
  });
  const { check } = usePassengerNameLengthCheck(dataPassenger);
  const { onFetchData: onFetchCreateOrder, isLoading: isLoadingCreateOrder } =
    useFetchData({
      actionApi: getCreateOrderHolidayApi,
      IIFE: false,
      onSuccess: response => {
        clearSelectedFlights();
        clearSelectedTickets();
        clearSelectedHotels();
        clearComboSessionId();
        clearPassengerInfoForm();
        clearSpecialRequest();
        const orderCode = response.thirdPartySubmitNumber;
        history.push(`/holiday/checkout/${orderCode}`);
      },
    });
  const { onFetchData: onFetchConfirmPrice, isLoading: isLoadingConfirmPrice } =
    useFetchData({
      actionApi: getConfirmPriceApi,
      IIFE: false,
      onSuccess: response => {
        callCreateOrderWhenConfirmPriceSuccess(response);
      },
    });
  const onClickBackPassenger = () => {
    history.goBack();
    // const tripType = dataFlight?.length > 1 ? 'round-trip' : 'one-way';
    // const isFlightHotelCombo = dataAllCombo?.[0]?.comboType === 'FHT';
    // const params: Record<string, string> = {
    //   adults: String(totalAdult),
    //   children: String(totalChild),
    //   infants: String(totalInfants),
    //   tripType,
    //   comboType: isFlightHotelCombo
    //     ? COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL_TICKET
    //     : COMBO_HOLIDAY_TYPES.FLIGHT_TICKET,
    // };
    // if (isFlightHotelCombo) {
    //   params.checkin = searchParams.get('checkin') ?? '';
    //   params.checkout = searchParams.get('checkout') ?? '';
    //   params.room = searchParams.get('room') ?? '1';
    // }
    // const queryParams = new URLSearchParams(params);
    // history.replace(`/holiday/passenger-info?${queryParams.toString()}`);
  };
  const onClickPayment = () => {
    const { valid, errors } = check();
    if (!valid) {
      openMessageWithIcon('error', errors?.[0].message);
      return;
    } else {
      const listPassenger = dataPassenger.map((item, index) => ({
        paxId: index + 1,
        type:
          item.type === 'ADT'
            ? 'ADULT'
            : item.type === 'CHD'
            ? 'CHILD'
            : item.type === 'INF'
            ? 'INFANT'
            : item.type,
        title: item.title,
        firstName: item.firstName,
        lastName: item.lastName,
        dateOfBirth: item.dateOfBirth
          ? moment(item.dateOfBirth).format('YYYY-MM-DD')
          : '',
        passport:
          item?.documentType === DocumentType.CITIZEN_ID ||
          item?.documentType === DocumentType.PASSPORT
            ? item?.documentNumber
            : '',
        nationality: '',
        parentId:
          item.type === 'INF' && dataPassenger[Number(item.guardian)].id
            ? Number(dataPassenger[Number(item.guardian)].id.split('-')[1])
            : 0,
        ...(item.documentType === DocumentType.CITIZEN_ID ||
        item.documentType === DocumentType.PASSPORT
          ? {
              document: {
                type: item.documentType === DocumentType.PASSPORT ? 'P' : 'I',
                number:
                  item.documentType === DocumentType.PASSPORT
                    ? item.passportNumber
                    : item.documentNumber,
                expiryDate: item.expiryDate || '',
                country: item.issuedPlace || '',
                nationality: item.nationality || '',
                gender:
                  item.gender === 'Nam' ? 'M' : item.gender === 'Nữ' ? 'F' : '',
              },
            }
          : {}),
      }));
      const listItinerary = dataFlight.map((item, index) => {
        return {
          route: item?.route?.route || '',
          tripId: item?.trip?.tripId || '',
          bookingClass: item?.pricing?.bookingClass || '',
        };
      });
      const isIncludeAllTicket = dataAllCombo?.[0]?.isIncludeAllTicket ? 1 : 0;
      const comboType =
        dataAllCombo?.[0]?.comboType || COMBO_HOLIDAY_TYPES.FLIGHT_TICKET;
      const ticketIds = dataAllCombo
        ?.map(({ ticket }) => ticket?.id)
        .filter(Boolean);
      const hotelNights =
        (comboType === COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL_TICKET ||
          comboType === COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL) &&
        calculateHotelNights(checkin, checkout);
      const hotel = {
        isIncludeAllTicket,
        comboType,
        arrivalDate: checkin,
        lengthOfStay: hotelNights,
        hotelId: dataHotel?.[0]?.hotel.id,
        roomTypeId: dataHotel?.[0]?.roomTypes?.[0]?.roomType?.id,
        ratePlanId: dataHotel?.[0]?.roomTypes?.[0]?.pricing?.ratePlanId,
        comment: dataSpecialRequest || '',
        roomOccupancy: {
          numberOfAdult: totalAdult,
          numberOfChild: totalChild,
          numberOfInfant: totalInfants,
          numberOfRoom: room,
        },
      };
      const params = {
        comboType,
        isIncludeAllTicket,
        comboId: dataCombo?.comboIds?.[0] || '',
        comboCode: dataCombo?.comboCode || '',
        totalAmount: totalAmount,
        totalPayment: totalPayment,
        discount: discount,
        commission: commission,
        // ticketId: dataCombo.id,
        ticketIds,
        paymentMethod:
          resPaymentMethod?.data?.filter(el => el.code === 'Deposit')?.[0]
            ?.mapVGS || 'G',
        flight: {
          listItinerary: listItinerary,
          listPassenger: listPassenger,
          contactInfo: {
            email: dataContact?.email || '',
            phoneNumber: `${dataContact.countryCode}${dataContact.phone}`,
            fullName: dataContact.fullName,
          },
          dataSessionId: JSON.parse(
            sessionStorage.getItem(SESSION_KEYS.COMBO_SESSION_ID) as string,
          ),
        },
        ...((comboType === COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL_TICKET ||
          comboType === COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL) && {
          hotel,
        }),
      };
      paramCreateOrderRef.current = params;
      const paramsConfirm = convertParamToConfirmPrice();
      onFetchConfirmPrice({ payloadData: paramsConfirm });
    }
  };
  const convertParamToConfirmPrice = () => {
    const { paymentMethod, totalAmount, flight, ...rest } =
      paramCreateOrderRef.current;
    return {
      ...rest,
      flight: {
        listItinerary: flight?.listItinerary,
        dataSessionId: flight?.dataSessionId,
      },
    };
  };
  const callCreateOrderWhenConfirmPriceSuccess = (response: any) => {
    const params = {
      ...paramCreateOrderRef.current,
      totalAmount: response.totalAmount,
      totalPayment: response.totalPayment || 0,
      discount: response.discountCombo || 0,
      commission: response.percentageCombo || 0,
    };
    onFetchCreateOrder({ payloadData: params });
  };
  const onClickTerm = () => {
    const region = 'vn';
    const locale = getCookie(TYPE_COOKIE.LANGUAGE) || DEFAULT_LANGUAGE;
    const urlPolicy = `https://www.sunphuquocairways.com/${region}/${locale}/spa-holidays/terms-and-conditions`;
    window.open(urlPolicy, '_blank');
  };
  const { priceForAPerson, totalAmount, discount, commission, totalPayment } =
    useMemo(() => {
      const totalPaxAdditionalAmount =
        dataFlight?.reduce(
          (sum, item) => sum + Number(item?.pricing?.paxAdditionalAmount || 0),
          0,
        ) || 0;
      const totalAdditionalAmount =
        dataFlight?.reduce(
          (sum, item) => sum + Number(item?.pricing?.additionalAmount || 0),
          0,
        ) || 0;
      const priceForAPerson = +(dataCombo?.paxPrice || 0);
      const totalAmount = +(dataCombo?.totalPrice || 0);
      const discount = +(dataCombo?.discount || 0);
      const commission = +(dataCombo?.commission || 0);
      const totalPayment = +(dataCombo?.totalPayment || 0);
      return {
        totalPaxAdditionalAmount,
        totalAdditionalAmount,
        priceForAPerson,
        totalAmount,
        discount,
        commission,
        totalPayment,
      };
    }, [dataFlight, dataCombo?.totalPrice, totalAdultAndChild]);
  return (
    <div>
      <LoadingContainer
        loading={
          isLoadingPaymentMethod ||
          isLoadingCreateOrder ||
          isLoadingConfirmPrice
        }
      >
        <HeaderStep />
        <ContainerFluid>
          <PaymentHolidayInformationWrapper>
            <Row gutter={24}>
              <Col span={device === 'tablet' || device === 'mobile' ? 24 : 16}>
                <div className="boxLeft">
                  <FlightInformation
                    flightInfo={dataFlight}
                    comboInfo={dataAllCombo}
                    hotelInfo={dataHotel}
                    dataAirports={dataAirports}
                    dataPassenger={dataPassenger}
                  />
                  <BoxPassengerInformation>
                    <Title>
                      {translations?.['b2b.txt.passengerInformation']}
                    </Title>
                    <Line />
                    <PassengerInformation dataPassenger={dataPassenger} />
                  </BoxPassengerInformation>
                  <BoxPassengerInformation>
                    <Title>{translations?.['b2c.ref.contactInfo']}</Title>
                    <Line />
                    <ContactInformation dataContact={dataContact} />
                  </BoxPassengerInformation>
                  {dataSpecialRequest && (
                    <SpecialRequest
                      translations={translations}
                      value={dataSpecialRequest}
                    />
                  )}
                </div>
              </Col>
              <Col span={device === 'tablet' || device === 'mobile' ? 24 : 8}>
                <SharedBoxRight>
                  <PriceDetailText>
                    {translations?.['b2b.txt.priceDetails']}
                  </PriceDetailText>
                  <PassengerLabel>{textPassenger}</PassengerLabel>
                  <RowPayment>
                    <TitleLabel>
                      {translations?.['b2b.txt.comboUnitPrice']}
                    </TitleLabel>
                    <PaymentLabel>
                      {formatNumber(priceForAPerson, '.')}đ/
                      {translations?.['b2b.txt.personUnit']}
                    </PaymentLabel>
                  </RowPayment>
                  <RowPayment>
                    <TitleLabel>
                      {translations?.['b2b.txt.totalOrderValue']}
                    </TitleLabel>
                    <PaymentLabel $bold $size={16}>
                      {formatNumber(totalAmount, '.')}đ
                    </PaymentLabel>
                  </RowPayment>
                  <RowPayment>
                    <TitleLabel>
                      {renderReplaceText(
                        translations?.['b2b.txt.discountCommission'],
                        {
                          commission: String(commission),
                        },
                      )}
                    </TitleLabel>
                    <PaymentLabel $bold $size={16}>
                      {discount > 0 && '-'}
                      {formatNumber(discount, '.')}đ
                    </PaymentLabel>
                  </RowPayment>
                  <div className="divider" />
                  <RowPayment>
                    <TitleLabel style={{ color: '#000', fontSize: 16 }}>
                      {translations?.['b2b.txt.paymentBefore']}
                    </TitleLabel>
                    <PaymentPrice>
                      {formatNumber(totalPayment, '.')}đ
                    </PaymentPrice>
                  </RowPayment>

                  <NoteBox>
                    <NoteTitle>
                      {translations?.['b2b.txt.bookingNotes']}
                    </NoteTitle>
                    <NoteContent>
                      {translations?.['b2b.txt.vietnamTaxNotice']}
                    </NoteContent>
                  </NoteBox>
                  <PaymentMethodComponent>
                    <div className="title d-flex align-items-center">
                      <h3>{translations?.['b2b.table.payment'] ?? ''}</h3>
                    </div>
                    <div className={styles.checkboxContainer}>
                      {resPaymentMethod?.data
                        ?.filter(el => el.code === 'Deposit')
                        ?.map(i => {
                          const value = i?.id;
                          return (
                            <StyledCheckbox key={value} checked value={value}>
                              <span
                                style={{
                                  textTransform: 'uppercase',
                                  fontSize: 12,
                                }}
                              >
                                {i?.name || i?.code}
                              </span>
                            </StyledCheckbox>
                          );
                        })}
                    </div>
                  </PaymentMethodComponent>
                  <div className="d-flex gap-2 align-items-center">
                    <Checkbox
                      style={{ margin: '6px 0px' }}
                      checked={isAgreeTerm}
                      onChange={e => {
                        setIsAgreeTerm(!isAgreeTerm);
                      }}
                    ></Checkbox>
                    <BlockTerm>
                      <span>
                        {translations?.['b2b.txt.iHaveReadAndAgree']}{' '}
                        <TextTerm onClick={onClickTerm}>
                          {translations?.['b2b.txt.termsAndConditionsPolicy']}
                        </TextTerm>
                      </span>
                    </BlockTerm>
                  </div>
                </SharedBoxRight>
                <Footer>
                  <ButtonBack onClick={onClickBackPassenger}>
                    <i className="fa-solid fa-chevron-left me-2"></i>
                    {translations?.['b2b.txt.goBack']}
                  </ButtonBack>
                  <ButtonPayment
                    onClick={onClickPayment}
                    disabled={
                      !isAgreeTerm ||
                      _.isEmpty(
                        resPaymentMethod?.data?.filter(
                          el => el.code === 'Deposit',
                        ),
                      )
                    }
                  >
                    {translations?.['b2b.txt.goToPayment']}
                  </ButtonPayment>
                </Footer>
              </Col>
            </Row>
          </PaymentHolidayInformationWrapper>
        </ContainerFluid>
      </LoadingContainer>
    </div>
  );
};
const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
`;
const Line = styled.div`
  height: 1px;
  background-color: #e5e5e5;
  margin: 12px -11px;
`;
const BoxPassengerInformation = styled.div`
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 20px;
`;
const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
`;
const ButtonBack = styled.button`
  background: transparent;
  color: #000;
  border: none;
  font-size: 14px;
  &:hover {
    opacity: 0.8;
  }
`;
const ButtonPayment = styled.button`
  background: var(--color-gradient);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  padding: 10px 20px;
  &:hover {
    opacity: 0.8;
  }
  :disabled {
    background: #ccc;
    opacity: 1;
  }
`;
// styling moved to shared component (PaymentStyles.ts)
const PaymentMethodComponent = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  h3 {
    margin: 0 0 0 0px;
    font-size: 14px;
    font-weight: 600;
  }
`;
const StyledCheckbox = styled(Checkbox)`
  &.ant-checkbox-wrapper {
    &:not(:first-child) {
      margin-top: 8px;
      margin-left: 0;
    }
    width: max-content;
    .ant-checkbox-inner {
      border-radius: 50%;
    }
    .ant-checkbox {
      & + span {
        color: #000000;
      }
    }
    .ant-checkbox-checked {
      &:after {
        border-radius: 50%;
      }
    }
  }
`;
const BlockTerm = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
`;
const TextTerm = styled.span`
  color: var(--color-9);
  font-size: 12px;
  margin-top: 5px;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
    color: var(--color-9);
  }
`;
export const PriceDetailText = styled.div`
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 8px;
`;
export const PassengerLabel = styled.div`
  font-size: 14px;
  margin-bottom: 16px;
`;
export const TitleLabel = styled.div`
  font-size: 14px;
  color: #8c8c8c;
`;
export const RowPayment = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 6px;
`;
export const PaymentLabel = styled.div<{ $bold?: boolean; $size?: number }>`
  font-size: ${({ $size }) => $size || 14}px;
  color: ${({ $bold }) => ($bold ? '#000' : '#8c8c8c')};
  font-weight: ${({ $bold }) => ($bold ? 500 : 400)};
`;
export const PaymentPrice = styled.div`
  font-size: 22px;
  font-weight: 700;
  text-align: right;
  max-width: 70%;
  color: var(--color-9);
`;
